if (
  document.querySelector('.a2a_kit') &&
  !document.querySelector('script[src$="addtoany.js"]')
) {
  const el = document.createElement('script');
  el.src = '/content/js/addtoany.js';
  document.body.appendChild(el);
}
